import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eye-show",
  "use": "icon-eye-show-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eye-show\"><path fill=\"#333\" d=\"M512 384.213a170.667 170.667 0 1 1 0 341.334 170.667 170.667 0 0 1 0-341.334zm0-149.546c196.864 0 366.763 134.4 413.91 322.73a32 32 0 1 1-62.08 15.574 362.795 362.795 0 0 0-703.702.17 32 32 0 0 1-62.08-15.488A426.795 426.795 0 0 1 512 234.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol